import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param assets Array Asset serials optional list. When this is empty all available measurements for the organisation are returned
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, assets) {
    if (assets === void 0) { assets = []; }
    var url = applyPathVariables(EndPoints.METRICS_AVAILABLE, { organisationId: organisation.id });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: assets });
    return request.execute();
});
